/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { FormFieldStyle } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { sharedMyAccountDetailsLinesStyles } from "@monsma/App/ComponentExtensions/OrderLinesListExtension";
import { requestRmaProductListStyles } from "@monsma/Overrides/Widgets/RequestRma/RequestRmaProductList";
import { screen } from "@monsma/XDL/Helpers";
import { sharedSelectListStyles } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

requestRmaProductListStyles.qtyToReturnTextField = {
    sizeVariant: "small",
    cssOverrides: {
        formInputWrapper: css`
            ${getProp("theme.formField.defaultProps.cssOverrides.formInputWrapper")}
            width: 92px;
            margin-right: 20px;
        `,
        inputSelect: css`
            ${getProp("theme.formField.defaultProps.cssOverrides.inputSelect")}
            background: ${getColor("common.ui8")};
            font-size: 14px;

            &:focus {
                padding-right: 10px !important;
            }
        `,
        formField: css`
            width: auto;
        `,
    },
};

requestRmaProductListStyles.returnReasonSelect = {
    ...(sharedSelectListStyles.selectList as any),
    labelProps: {
        css: css`
            width: 100%;
            line-height: 18px;
            min-height: 18px;
        `,
    },
};

requestRmaProductListStyles.xRequestRmaProductListStyles = {
    titleText: sharedMyAccountDetailsLinesStyles.titleText,

    qtyToReturnWrapper: {
        css: css`
            display: inline-flex;
        `,
    },

    headingAndTextStyles: sharedMyAccountDetailsLinesStyles.smallHeadingAndTextContent,
    subTotalWrapper: {
        css: css`
            margin-top: 10px;
        `,
    },
    requestRmaMsg: {
        css: css`
            margin-top: 10px;
            text-align: right;
            font-size: 14px;
        `,
    },

    uploadImageWrapper: {
        css: css`
            padding: 0;
            padding-left: 20px;

            ${screen("lte", "sm")} {
                padding: 0;
                margin: 10px 0;
            }

            > div {
                width: 200px;

                ${screen("lte", "sm")} {
                    width: 100%;
                }
            }

            &.uploadDisabled {
                cursor: not-allowed;

                input[type="file"] {
                    display: none;
                }

                ${FormFieldStyle} {
                    opacity: 0.5;
                    pointer-events: none;
                }
            }
        `,
    },
    fileUploader: {
        cssOverrides: {
            inputSelect: css`
                height: 33px;
                border-color: ${getColor("common.ui9")};
            `,
            appearanceTransition: css`
                display: none;
                &&& > button {
                    right: 35px;
                }

                ${IconWrapper} {
                    top: 0;
                    right: 0;
                    width: 31px;
                    height: 31px;
                    padding: 2px;
                }
            `,
        },
        iconProps: {
            css: css`
                &&& {
                    top: 0;
                    right: 0;
                    width: 31px;
                    height: 31px;
                    padding: 2px;
                }
            `,
        },
    },
    uploadingWrapper: {
        css: css`
            display: flex;
            flex-direction: row;

            ${screen("lte", "sm")} {
                flex-direction: column;
            }
        `,
    },

    orderWithinRmaEligibilityLimitMsg: {
        css: css`
            margin-top: 10px;
        `,
    },
};
